import request from '@/utils/request'

// 列表(主数据列表)
export function loadActivityDispatchBillListDataApi(data) {
  return request({
    url: 'web/activityDispatchBill/listData',
    method: 'post',
    data
  })
}

// 操作
export function saveOrUpdateActivityDispatchBillApi(data) {
  return request({
    url: 'web/activityDispatchBill/saveOrUpdate',
    method: 'post',
    data
  })
}

// 查看
export function initActivityDispatchBillApi(data) {
  return request({
    url: 'web/activityDispatchBill/init',
    method: 'post',
    data
  })
}

// 根据条件查询派工单
export function findDispatchBillByConditionApi(data) {
  return request({
    url: 'web/activityDispatchBill/findDispatchByCondition',
    method: 'post',
    data
  })
}

// 根据条件查询派工单条数
export function findDispatchCountByConditionApi(data) {
  return request({
    url: 'web/activityDispatchBill/findDispatchCountByCondition',
    method: 'post',
    data
  })
}

// 根据条件查询派工人员场次天数超限数据
export function findDispatchUserWorkHourErrorApi(data) {
  return request({
    url: 'web/activityDispatchBill/findDispatchUserWorkHourError',
    method: 'post',
    data
  })
}

// 导出现场执行照片PDF
export function exportSitePDFApi(data) {
  return request({
    url: 'web/activityDispatchBill/exportSitePDF',
    method: 'post',
    data
  })
}

// 签到签退列表(主数据列表)
export function loadActivityDispatchSignInfoListDataApi(data) {
  return request({
    url: 'web/activityDispatchSignInfo/listData',
    method: 'post',
    data
  })
}
// 签到签退导出
export function loadActivityDispatchSignInfoExportDataApi(data) {
  return request({
    url: 'web/activityDispatchSignInfo/exportData',
    method: 'post',
    data
  })
}
// 根据派工查询负责人签到信息及参与者图片
export function findSignInfoAndAttachmentInfoByDispatchIdApi(data) {
  return request({
    url: 'web/activityDispatchSignInfo/findSignInfoAndAttachmentInfoByDispatchId',
    method: 'post',
    data
  })
}
